import {useContext, useEffect, useState} from 'react';
import {TRY_AGAIN_IN_15_MINUTES} from '../libs/messages'

import {useHistory} from 'react-router-dom';

import {scan} from '../libs/api';
import Spinner from '../components/common/Spinner';
import LandingPage from '../components/common/LandingPage';
import ErrorMessage from '../components/common/ErrorMessage';
import {invalidQR} from '../libs/helpers';
import {AppContext} from "../context/AppContext";


const Scan = ({match}) => {
    const {qrCodeID, eventID} = match.params;

    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState('');
    const [showLandingPage, setShowLandingPage] = useState(false);

    const history = useHistory();

    const {setAppData} = useContext(AppContext);

    useEffect(() => {
        (async () => {
            try {
                const result = await scan(eventID, qrCodeID);

                if (!result.error) {
                    const {content} = result.data;

                    if (content.expired) {
                        setShowLandingPage(false);
                        setHasError(true);
                        setMessage(invalidQR(content));
                        return;
                    }

                    const {eventID, orgCommitteeCode, organizationName} = content;
                    const data = {
                        eventID,
                        qrCodeID,
                        title: content.title,
                        sessionID: result.sessionID,
                        orgCommitteeCode,
                        organizationName
                    };

                    setAppData(data);

                    history.push('/step/1', {
                        from: 'SCAN'
                    });
                } else {
                    setShowLandingPage(false);
                    setHasError(true);
                    setMessage(result.message);
                }
            } catch (err) {
                console.log(err);
                setShowLandingPage(false);
                setHasError(true);
                setMessage(TRY_AGAIN_IN_15_MINUTES);
            }
        })();
    }, [history, eventID, qrCodeID]);

    return (
        <div className={`app-scan`}>
            {(!hasError && !showLandingPage) ? <Spinner/> : !showLandingPage && <ErrorMessage message={message}/>}
            {!hasError && showLandingPage && <LandingPage url={`/step/1`}/>}
        </div>
    );
};

export default Scan;
